import request from '@/utils/request'
import store from '@/store'

//获取首页数据
export function getHomeData() {
  return request({
    url: store.getters.urlStatus
      ? '/official/setting/indexass'
      : '/official/setting/index',
    method: 'get',
    loading: false
  })
}

// 首页预览
// export function getIndexass() {
//   return request({
//     url: '/official/setting/indexass',
//     method: 'get',
//     loading: false
//   })
// }

// 企业优势
export function getAdvantage() {
  return request({
    url: store.getters.urlStatus
      ? '/official/setting/advantageass'
      : '/official/setting/advantage',
    method: 'get',
    loading: false
  })
}
